import React from 'react';
import './SetAccountModal.scss';
import Modal from 'react-modal';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		padding: '40px',
		transform: 'translate(-50%, -50%)',
		// height: '60%',
		width: '50%',
		boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)'
	}
};

const SetAccountModal = ({
	showModal,
	handleCloseModal,
	thisMember,
	handleSave,
	onChange,
	inputValue,
	handleRemove
}) => {
	let style = {
		color: '#8b1303',
		cursor: 'pointer',
		textDecoration: 'underline'
		// display: !hiddenContent ? 'none' : null
	};
	return (
		<div className="grid-container">
			<div className="desktop:grid-col-8 mobile-lg:grid-col-12 tablet:grid-col-8 modal-button-container">
				<Modal isOpen={showModal} style={customStyles} overlayClassName="Overlay">
					<form className="usa-form" id="selectAccountType">
						<fieldset className="usa-fieldset">
							<div className="grid-row">
								<div className="usa-header-profile grid-col-10">
									<h2 className="usa-flag-page-header ModalHeader">Member Roles(s)</h2>
									<p className="headerInfo">
										Manage permission for <strong>{thisMember.first_name || null}</strong> {' '}
										<strong>{thisMember.last_name || null}</strong>
										.
									</p>
								</div>
							</div>
							<legend className="usa-sr-only">Member Roles</legend>
							<div className="box-grey">
								<input
									// className="usa-radio__input"
									id="Owner"
									type="radio"
									name="historical-figures-2"
									value="Owner"
									onChange={(e) => {
										onChange(e);
									}}
								/>
								<label htmlFor="Owner">
									Master Account
								</label>
								<ul className="masterAccountlist">
									<li className="masterAccountlistli">Submit Applications</li>
									<li className="masterAccountlistli">Manage Profiles</li>
									<li className="masterAccountlistli">Re-assign Cases</li>
									<li className="masterAccountlistli">Invite new members</li>
									<li className="masterAccountlistli">Deactivate Members</li>
									<li className="masterAccountlistli">Manage member roles</li>
								</ul>
							</div>
							<div className="box-grey">
								<input
									// className="usa-radio__input"
									id="Subaccount"
									type="radio"
									name="historical-figures-2"
									value="Subaccount"
									onChange={(e) => {
										onChange(e);
									}}
								/>
								<label htmlFor="Subaccount">
									Sub-Account
								</label>
								<ul>
									<li className="subaccountlistli">Initiate applications </li>
									<li className="subaccountlistli">Use profiles</li>
									<li className="subaccountlistli">View their cases</li>
								</ul>
							</div>
						</fieldset>
					</form>
					<div id="modalFooter">
						<span className="item-1">
							<span
								tabIndex="0"
								style={style}
								className={'underline-secondary-darker .text-underline'}
								onClick={handleRemove}
							>
								Remove {thisMember.first_name || null} {thisMember.last_name || null}
							</span>
						</span>
						<span className="item-2">
							<button className="usa-button usa-button--outline cancelButton" onClick={handleCloseModal}>
								Cancel
							</button>
						</span>
						<span className="item-3">
							<button
								className="usa-button"
								disabled={!inputValue}
								onClick={() => {
									handleSave();
									handleCloseModal();
								}}
							>
								Save
							</button>
						</span>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default SetAccountModal;
